<template>
  <div class="card is-min-width-700"
    v-if="!chargement">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-40px">
            <h1 class="title is-size-3">
              <span v-if="modeModification">
                {{ $t('demandeLogistique.creationOrUpdate.titleUpdate') }}
              </span>
              <span v-else>
                {{ $t('demandeLogistique.creationOrUpdate.titleCreate') }}
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
      <error-msg-component :messages="messages"
                              :error="error"
                              :messagesChampsVide="messagesChampsVide"
                              :champsVide="champsVide"
                              title="general.problemOccurred"
                              :withEmplyFields="true"
                              @close="error = $event"/>
        <div class="columns is-multiline mgt-20px">
          <div class="column is-12">
            <information-patrimoine
              :faceId="face ? face.id : ''"
              :materielId="materiel ? materiel.id : ''"
              :dispositifId="dispositif ? dispositif.id : ''"
              :emplacementId="emplacement ? emplacement.id : ''">
            </information-patrimoine>
          </div>
          <b-field :label="$t('demandeLogistique.creationOrUpdate.datePlanification')"
                  class="column is-narrow mgb-0 obligatoire">
            <b-datepicker
                  show-week-number
                  icon="calendar-today"
                  v-model="creationDemandeParametre.datePlanification"
                  nearby-selectable-month-days
                  editable>
              </b-datepicker>
          </b-field>
          <b-field
            :label="$t('demandeLogistique.creationOrUpdate.typeIntervention')"
            class="column is-3">
            <b-select
              v-model="creationDemandeParametre.type"
              expanded>
              <option
                v-for="item in constantes.TYPE_INTERVENTION"
                :key="item.key"
                :value="item.key">
                {{ $t(item.libelle) }}
              </option>
            </b-select>
          </b-field>
          <div class="column is-3">
            <user-autocomplete
              v-model="creationDemandeParametre.demandeurId"
              :label="$t('demandeLogistique.creationOrUpdate.demandeur')"
              :obligatoire="isIntervention"
            />
          </div>
          <div class="column is-3" v-if="agencesSelectionnees.length > 1">
            <selection-agence
              v-model="creationDemandeParametre.agenceId"
              :obligatoire="true"
              setFirstAgenceFind>
            </selection-agence>
          </div>
          <div class="column is-3" v-if="isIntervention">
            <b-field
              class="obligatoire"
              :label="$t('editionIntervention.infoGenerale.typeOt')">
              <b-select v-model="creationDemandeParametre.typeOtId" expanded>
                <option
                  v-for="item in typesOT"
                  :key="item.id"
                  :value="item.id">
                  {{ item.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <b-field :label="$t('demandeLogistique.creationOrUpdate.actionLogistique')"
                  class="column is-12 mgb-0 obligatoire">
            <b-input v-model="creationDemandeParametre.actionLogistique"
              type="textarea" maxlength="255">
            </b-input>
          </b-field>
          <div class="column is-12 boutonAction">
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="sauvegarde()">
                <span v-if="modeModification">
                  {{ $t('demandeLogistique.creationOrUpdate.updateAffichage') }}
                </span>
                <span v-else>
                  {{ $t('demandeLogistique.creationOrUpdate.createAffichage') }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { createAll, update } from '@/api/logistique/demandeLogistique/index';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import formatDate from '@/services/general/formatIsoDate';
import gestionDateBase from '@/services/general/gestionDateBase';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/logistique/demandeLogistique/validation';
import translate from '@/services/logistique/demandeLogistique/translator';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import selectionAgence from '@/components/general/selectionAgence';
import {
  TYPE_INTERVENTION, INTERVENTION_TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererDemandeIntervention from '@/services/logistique/intervention/genererDemandeIntervention';
import informationPatrimoine from '@/components/gabed/general/informationPatrimoine';
import userAutocomplete from '@/components/commun/user/userAutocomplete';
import snackBarSuccess from '@/services/general/snackbar/snackBarSuccess';

const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_creationDemande',
  props: {
    demandeLogistique: {
      type: Object,
      required: false,
    },
    face: {
      type: Object,
      required: false,
    },
    materiel: {
      type: Object,
      required: false,
    },
    dispositif: {
      type: Object,
      required: false,
    },
    emplacement: {
      type: Object,
      required: false,
    },
    agenceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      creationDemandeParametre: {},
      importedFunction: {
        adressFullStringGetter,
      },
      chargement: false,
      constantes: {
        TYPE_INTERVENTION,
      },
    };
  },
  components: {
    errorMsgComponent,
    selectionAgence,
    informationPatrimoine,
    userAutocomplete,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    modeModification() {
      return !!this.demandeLogistique;
    },
    isIntervention() {
      return this.creationDemandeParametre.type === INTERVENTION_TYPE_INTERVENTION;
    },
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    async sauvegarde() {
      if (this.modeModification) {
        await this.updateDemande();
        return;
      }
      await this.createDemande();
    },
    async updateDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandeAUpdate = cloneDeep(this.creationDemandeParametre);
        demandeAUpdate.datePlanification = formatDate(
          demandeAUpdate.datePlanification,
        );
        const demandeRetour = (await update(demandeAUpdate)).data.result;
        demandeRetour.datePlanification = formatDate(demandeRetour.datePlanification);
        messageSucces(this.$t('demandeLogistique.creationOrUpdate.success'));
        loadingComponent.close();
        this.$emit('refreshList', demandeRetour);
        this.$parent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async createDemande() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = [{
          ...this.creationDemandeParametre,
          datePlanification: formatDate(this.creationDemandeParametre.datePlanification),
          societeId: this.societeActiveId,
        }];

        const retourCreation = (await createAll(params)).data.result;
        if (this.face) this.face.demandesLogistique.push(retourCreation[0]);

        snackBarSuccess(
          this.$i18n.t('demandeLogistique.creationOrUpdate.success'),
          this.$i18n.t('demandeLogistique.creationOrUpdate.goToDemande'),
          () => {
            this.$router.push({
              name: 'c.logistique.demande_intervention',
              params: { id: retourCreation[0].id },
            });
          },
        );

        loadingComponent.close();
        this.$parent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    initDemandeIntervention() {
      const demandeIntervention = genererDemandeIntervention();
      demandeIntervention.agenceId = this.agenceId;
      demandeIntervention.datePlanification = moment().toDate();
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find(u => u.id === this.user.id);
      if (userFind) demandeIntervention.demandeurId = this.user.id;
      return demandeIntervention;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.chargement = true;
    try {
      if (!this.demandeLogistique && !this.face && !this.materiel
          && !this.dispositif && !this.emplacement) {
        messageErreur(this.$i18n);
        throw (new Error('Manque paramètre'));
      }
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      this.creationDemandeParametre = this.initDemandeIntervention();
      if (this.demandeLogistique) {
        this.creationDemandeParametre = cloneDeep(this.demandeLogistique);
        this.creationDemandeParametre.datePlanification = gestionDateBase(
          this.creationDemandeParametre.datePlanification,
        );
      }
      if (this.face) {
        this.creationDemandeParametre.produitId = this.face.produitId;
        this.creationDemandeParametre.faceId = this.face.id;
      }
      if (this.materiel) {
        this.creationDemandeParametre.materielId = this.materiel.id;
      }
      if (this.dispositif) {
        this.creationDemandeParametre.dispositifId = this.dispositif.id;
      }
      if (this.emplacement) {
        this.creationDemandeParametre.emplacementId = this.emplacement.id;
      }
      this.chargement = false;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      this.chargement = false;
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
